import { employementStatus } from "../commonSelectBoxOptions/commonSelectBoxOptions";
import {EMPLOYEE_ACCOUNT_STATUS} from "../../../src/redux/constants/actvityType"

const styleMap = {
  [EMPLOYEE_ACCOUNT_STATUS.ACTIVE]: {
    bgColor: "#FFFFFF",
    borderColor: "#059669",
    fontColor: "#059669",
  },
  [EMPLOYEE_ACCOUNT_STATUS.ONBOARDING]: {
    bgColor: "#D1FAE5",
    borderColor: "none",
    fontColor: "#065F46",
  },
  [EMPLOYEE_ACCOUNT_STATUS.ON_LEAVE]: {
    bgColor: "#EDE9FE",
    borderColor: "none",
    fontColor: "#5B21B6",
  },
  [EMPLOYEE_ACCOUNT_STATUS.PROBATIONARY]: {
    bgColor: "#FEF3C7",
    borderColor: "none",
    fontColor: "#92400E",
  },
  [EMPLOYEE_ACCOUNT_STATUS.OFF_BOARDING]: {
    bgColor: "#FEE2E2",
    borderColor: "none",
    fontColor: "#991B1B",
  },
  [EMPLOYEE_ACCOUNT_STATUS.LONG_ABSENCE]: {
    bgColor: "#FDF6B2",
    borderColor: "none",
    fontColor: "#92400E",
  },
  [EMPLOYEE_ACCOUNT_STATUS.TERMINATED]: {
    bgColor: "#F8D7DA",
    borderColor: "none",
    fontColor: "#842029",
  },
  [EMPLOYEE_ACCOUNT_STATUS.RESIGNED]: {
    bgColor: "#E0F2FE",
    borderColor: "none",
    fontColor: "#0369A1",
  },
};

const employeeAccountStatusFormat = (status) => {
  const parsedStatus = Number(status);

  const label = employementStatus.find(
    (s) => Number(s.value) === parsedStatus
  )?.label || "Unknown";

  const style = styleMap[parsedStatus] || {
    bgColor: "#FFFFFF",
    borderColor: "#D1D5DB",
    fontColor: "#6B7280",
  };

  return {
    ...style,
    label,
    status: parsedStatus,
  };
};

export default employeeAccountStatusFormat;
